<gs1-header rootLink="/hub"  [img]="'../assets/images/logo-gs1-france.png'" [breakWidth]="1080" [connected]="isLoggedIn" [showDisconnect]="false" [appName]="'Espace Client'" [profileLabel]="'header.profil' | translate" class="fix">
    <a name="header-home" *ngIf="!isFederation" routerLinkActive="active" routerLink="/hub">{{'header.home' | translate}}</a>
    <a name="header-company" *ngIf="!isFederation" routerLinkActive="active" routerLink="/entreprise">
        {{'header.Entreprise.title' | translate}}
        <div *ngIf="companyDisplay" gs1HeaderMenu>
            <span class="gs1-color-ui-8 entreprise-name"><i class="bi bi-house"></i>{{nomEntreprise}}</span>
            <a name="header-company-info" routerLink="/entreprise/compte-entreprise">{{'header.Entreprise.info' | translate}}</a>
            <a name="header-company-activity"  routerLink="/entreprise/activite">{{'header.Entreprise.activity' | translate}}</a>
            <a name="header-company-ca" *ngIf="companyDisplay.activateCA" routerLink="/entreprise/chiffre-affaire">{{'header.Entreprise.ca' | translate}}</a>
            <a name="header-company-sepa" *ngIf="companyDisplay.activateSEPA" routerLink="/entreprise/moyens-de-paiement">{{'header.Entreprise.sepa' | translate}}</a>
            <a name="header-company-medias" *ngIf="companyDisplay.activateLogo" routerLink="/entreprise/medias">{{'header.Entreprise.medias' | translate}}</a>
            <a name="header-company-packs" *ngIf="companyDisplay.activatePacks && !disablePackSetting" routerLink="/entreprise/pack">{{'header.Entreprise.packs' | translate}}</a>
            <a id="company-change" *ngIf="multiple" gs1Button [name]="'company-change'" (click)="changeCompany()" [color]="'sky'" [thin]="true">{{'header.changerEntreprise' | translate}}</a>
        </div>
    </a>
   
    <a name="header-bills" *ngIf="!isFederation" routerLinkActive="active" routerLink="/factures">{{'header.billing' | translate}}</a>
    <a name="header-doc" *ngIf="!isFederation" routerLinkActive="active" routerLink="/documents">{{'header.documents' | translate}}</a>
    <a name="header-codes" *ngIf="!isFederation" routerLinkActive="active" routerLink="/codes">{{'header.codes' | translate}}</a>
    <a name="header-users" *ngIf="!isFederation" routerLinkActive="active" routerLink="/utilisateurs">{{'header.users' | translate}}</a>

    
    <div id="account-popin">
        <div class="utilisateur-info">
            <span class="name gs1-little">{{nomComplet}}</span>
            <span class="email gs1-small">{{emailAdherent}}</span>
        </div>
        <a *ngIf="!isFederation" name="header-profile" class="gs1-little gs1-color-blue" [routerLink]="['/formulaire-donnee-perso']">
            <i class="bi bi-gear"></i> {{'header.manage' | translate}}
        </a>
        <a name="header-logout" class="gs1-little" (click)="logout()"><i class="bi bi-box-arrow-right"></i> {{'header.deconnecter' | translate}}</a>
    </div>
</gs1-header>




